import { FormattedMessage } from 'react-intl';
import { CartSummarySkeleton } from './cart-summary';
import { CheckoutFormSkeleton } from './checkout-form';

export const CheckoutSkeleton = () => (
  <div className="container-fluid py-5">
    <h1 className="sr-only">
      <FormattedMessage
        id="payment.checkout.main.heading"
        defaultMessage="Payment"
        description="Heading For Checkout for Screen Readers"
      />
    </h1>
    <span className="sr-only">
      <FormattedMessage
        id="payment.checkout.skeleton.loading"
        defaultMessage="Loading, please wait..."
        description="Loading message for screen readers while checkout page is loading"
      />
    </span>

    <div className="row">
      <CartSummarySkeleton />
      <CheckoutFormSkeleton />
    </div>
  </div>
);
